import { Directive, Input, HostListener } from '@angular/core';

@Directive({
  selector: '[appValidateOnBlur]'
})
export class ValidateOnBlurDirective {
  @Input('validateFormControl') validateFormControl;
	constructor() { }

  @HostListener('focus', ['$event.target'])
  onFocus(target) {       
    this.validateFormControl.markAsUntouched();
  }
  @HostListener('focusout', ['$event.target'])
  onFocusout(target) {
    this.validateFormControl.markAsTouched();
  }
}


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/shared/validate-on-blur.directive.ts